<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="formTaskCommit" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24"
          v-if="
            operation.type !== SysFlowTaskOperationType.CO_SIGN &&
            operation.type !== SysFlowTaskOperationType.SIGN_REDUCTION &&
            operation.type !== SysFlowTaskOperationType.MULTI_SIGN
          "
        >
          <el-form-item label="审批意见：" prop="message">
            <el-input v-model="formData.message" clearable placeholder="请输入审批意见" />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showAssignSelect">
          <el-form-item label="指派用户：" prop="assignee">
            <TagSelect v-model="formData.assignee">
              <el-button slot="append" class="append-add" type="default" icon="el-icon-plus" @click="onSelectAssignee" />
            </TagSelect>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="operation.type === SysFlowTaskOperationType.SIGN_REDUCTION">
          <el-form-item label="减签用户：" prop="assignee">
            <el-select v-model="formData.assignee" placeholder=""
              clearable multiple collapse-tags
              :loading="multiSignAssignees.loading"
              @visible-change="multiSignAssignees.onVisibleChange"
            >
              <el-option v-for="item in multiSignAssignees.dropdownList" :key="item.assignee"
                :value="item.assignee" :label="item.showName"
                :disabled="item.approved"
              >
                <el-row type="flex" justify="space-between" align="middle">
                  <span>{{item.showName}}</span>
                  <el-tag v-if="item.approved" size="mini" type="info" style="margin-right: 10px;">已处理</el-tag>
                </el-row>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="processInstanceId != null && taskId != null && operation.type === SysFlowTaskOperationType.REJECT_TO_TASK">
          <el-form-item label="驳回节点：" prop="targetTaskKey">
            <el-select v-model="formData.targetTaskKey"
              :loading="taskWidget.loading"
              @visible-change="taskWidget.onVisibleChange"
            >
              <el-option v-for="item in taskWidget.dropdownList" :key="item.taskKey" :value="item.taskKey" :label="item.showName" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" @click="onSubmitClick()">
              提交
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import TagSelect from '@/views/workflow/components/TagSelect.vue';
import TaskUserSelect from '@/views/workflow/components/TaskUserSelect.vue';
import { DropdownWidget } from '@/utils/widget.js';
import { FlowOperationController } from '@/api/flowController.js';

export default {
  name: 'formTaskCommit',
  props: {
    operation: {
      type: Object,
      required: true
    },
    processInstanceId: {
      type: String
    },
    taskId: {
      type: String
    }
  },
  components: {
    TagSelect
  },
  data () {
    return {
      formData: {
        message: undefined,
        assignee: undefined,
        targetTaskKey: undefined
      },
      multiSignAssignees: new DropdownWidget(this.listMultiSignAssigneesDropdownData),
      taskWidget: new DropdownWidget(this.loadTaskWidgetDropdownData),
      rules: {
        message: [{required: true, message: '审批意见不能为空', trigger: 'blur'}],
        assignee: [{required: true, message: '指派用户不能为空', trigger: 'blur'}],
        targetTaskKey: [{required: true, message: '驳回节点不能为空', trigger: 'blur'}]
      }
    }
  },
  mounted () {
    console.log(this.operation)
    if (this.operation.type === 'agree') {
      this.formData.message = '同意'
    } else {
      this.formData.message = undefined
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    onSubmitClick () {
      this.$refs.formTaskCommit.validate(valid => {
        if (!valid) return;
        this.onCancel(true, this.formData);
      });
    },
    onSelectAssignee () {
      this.$dialog.show('选择用户', TaskUserSelect, {
        area: ['1000px', '600px']
      }, {
        showAssignee: false,
        showStartUser: (this.operation.type !== this.SysFlowTaskOperationType.CO_SIGN && this.operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION),
        multiple: this.multiSelect
      }).then(res => {
        let assignee = null;
        if (Array.isArray(res)) {
          // 多选需要合并两次选择
          let oldSelect = [];
          if (this.formData.assignee != null && this.formData.assignee !== '') {
            oldSelect = this.formData.assignee.split(',');
          }
          res.forEach(item => {
            if (oldSelect.indexOf(item.loginName) === -1) oldSelect.push(item.loginName);
          });
          assignee = oldSelect.join(',');
        } else {
          assignee = (res || {}).loginName;
        }
        this.formData.assignee = assignee;
      }).catch(e => {});
    },
    loadTaskWidgetDropdownData () {
      return new Promise((resolve, reject) => {
        FlowOperationController.listRejectCandidateUserTask(this, {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }).then(res => {
          resolve(res.data);
        }).catch(e => {
          reject(e);
        });
      });
    },
    listMultiSignAssigneesDropdownData () {
      return new Promise((resolve, reject) => {
        FlowOperationController.listMultiSignAssignees(this, {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }).then(res => {
          // 将已经处理过会签任务的处理人放到列表最后
          resolve(res.data.sort((val1, val2) => {
            return val1.approved === val2.approved ? 0 : (val1.approved ? 1 : -1);
          }));
        }).catch(e => {
          reject(e);
        });
      });
    }
  },
  computed: {
    showAssignSelect () {
      let showAssignSelect = false;
      // 如果是会签操作，判断是否在流程内设置了会签人
      if (this.operation.type === this.SysFlowTaskOperationType.MULTI_SIGN) {
        showAssignSelect = !this.operation.multiSignAssignee ||
          !Array.isArray(this.operation.multiSignAssignee.assigneeList) ||
          this.operation.multiSignAssignee.assigneeList.length <= 0;
      }
      return [
        this.SysFlowTaskOperationType.TRANSFER,
        this.SysFlowTaskOperationType.CO_SIGN,
        this.SysFlowTaskOperationType.SET_ASSIGNEE
      ].indexOf(this.operation.type) !== -1 || showAssignSelect;
    },
    multiSelect () {
      // 转办、加签、会签允许多选
      return [
        this.SysFlowTaskOperationType.CO_SIGN,
        this.SysFlowTaskOperationType.MULTI_SIGN,
        this.SysFlowTaskOperationType.TRANSFER,
        this.SysFlowTaskOperationType.SET_ASSIGNEE
      ].indexOf(this.operation.type) !== -1;
    }
  }
}
</script>

<style scoped>
  .append-add {
    border: none;
    border-left: 1px solid #DCDFE6;
    border-radius: 0px;
    background: #F5F7FA;
  }
</style>
